export const ADMIN_TITLE = "萝幼精选后台管理系统"
export const ADMIN_APPID = 1
export const IMAGE_CND_LINK= "https://d1rl3y90hza6y4.cloudfront.net"
export const VID_CND_LINK= "https://d1rl3y90hza6y4.cloudfront.net"
